



























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop({ type: String, default: "220" })
  private width: any;
  @Prop()
  private placeholder: any;
  @Prop()
  private options: any;
  @Prop()
  private val: any;
  private value: any = [];
  @Watch("val", { immediate: true })
  private valChange() {
    this.value = this.val;
  }
  private search(e: any) {
    this.$emit("search", e);
  }
  private focus(e: any) {
    if (e) {
      this.$emit("search", "");
    }
  }
  private change(e: any) {
    this.$emit("change", e);
  }
}
